import script from "./AlliedEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlliedEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./AlliedEditModal.vue?vue&type=style&index=0&id=d16f4860&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d16f4860"]])

export default __exports__